export default __webpack_public_path__ + "static/tgs-logo-white-3367aa38c4e9bcd10da2bbfb3da22952.png";